<template>
    <div class="columns is-multiline d-flex flex-column flex-md-row">
        <section class="sidebar column is-full-mobile is-4-tablet is-3-desktop">
            <cat-uxo-search-filters :query="query"></cat-uxo-search-filters>
            <cat-uxo-call-to-action class="mb-4 shape--top"></cat-uxo-call-to-action>
            <a class="btn w-100 mb-4" href="/contribute">Contribute a New Hazard</a>
            <cat-uxo-stacked-ads></cat-uxo-stacked-ads>
        </section>
        <section class="uxo-type column is-offset-1-desktop is-8 p-0">
            <template v-if="!fetchingHazards">
                <div v-if="hazardsCount > 0" class="columns is-mobile align-items-center mb-2">
                    <div class="columns is-multiline mb-3">
                        <div class="column is-full mb-1">
                            <h1 class="h2 font-weight-normal t-black">{{ hazardsCount }} Search Results</h1>
                        </div>
                        <div class="column is-9">
                            <cat-uxo-search-box :query="query"></cat-uxo-search-box>
                        </div>
                    </div>
                </div>
                <cat-uxo-list class="columns is-mobile is-multiline"></cat-uxo-list>
            </template>
            <template v-else>
                <div class="content-loader">
                    <ContentLoader
                        :height="56"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                        class="mb-2"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="460" height="56"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="56"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                        class="mb-2"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                </div>
            </template>
            <div v-if="pageCount" class="columns mb-4 mb-lg-0">
                <div class="column is-6 py-0 mx-auto">
                    <paginate
                        :page-count="pageCount"
                        :prev-text="'&nbsp;'"
                        :next-text="'&nbsp;'"
                        :prev-link-class="'pagination-previous'"
                        :next-link-class="'pagination-next'"
                        :container-class="'pagination-list'"
                        :page-class="'pagination-item'"
                        :page-link-class="'pagination-link'"
                        :click-handler="paginate">
                    </paginate>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import {ContentLoader} from 'vue-content-loader'
    import StackedAds from "../shared/StackedAds";

    export default {
        name: "CatUxoPageSearch",
        components: {
            ContentLoader,
            StackedAds,
        },
        props: {
            query: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {}
        },
        computed: {
            ...mapState('hazards', [
                'fetchingHazards',
                'hazardsCount',
                'uxoType'
            ]),
            ...mapState('search', [
                'filters'
            ]),
            ...mapGetters('hazards', [
                'pageCount',
            ])
        },
        methods: {
            ...mapActions('hazards', [
                'fetchUxoType',
                'fetchHazards',
            ]),
            ...mapActions('search', [
               'setFilters'
            ]),
            paginate: function (page) {
                window.scrollTo(0,0);
                this.fetchHazards({page: page, filters: this.filters})
            }
        },
        created() {
            let filters = this.filters;
            filters.query = this.query;
            this.setFilters(filters);

            this.fetchHazards({page: 1, filters: this.filters})
        },
        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    .content-loader {
        min-height: rem(200px);

        @include media-breakpoint-up(sm) {
            min-height: rem(300px);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/Search.vue